export default "__VITE_ASSET__Daus$6Fp__"